// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "wrapper-2uvAw";
var _4 = "links-x4hFt";
var _5 = "links_item-1-H3B";
var _6 = "addToAppleWallet-1w0JZ";
export { _1 as "__esModule", _2 as "mobile", _3 as "wrapper", _4 as "links", _5 as "links_item", _6 as "addToAppleWallet" }
export default { "__esModule": _1, "mobile": _2, "wrapper": _3, "links": _4, "links_item": _5, "addToAppleWallet": _6 }
